'use strict';
app.controller('internalTeamRegistrationController', ['$scope', 'LoginService', '$location', '$cookies', 'AuthenticationService', 'progressBarService', '$rootScope', '$timeout', '$http', '$routeParams', 'CommonService', function ($scope, loginService, $location, $cookies, AuthenticationService, progressBarService, $rootScope, $timeout, $http, $routeParams, commonService) {

    if ($cookies.get('TokenInfo') == undefined || localStorage.getItem('appInfo') == undefined || getLocalValue('userRole') != 'SAdmin') {
        $location.path('/login');
        return false;
    }

    var serviceBase = $rootScope.buildConfig.aippsssApiBaseUrl;

    $scope.selectedInstitute = {
        InstitutionId: 0,
        InstitutionName: '',
        isAffiliationExists: false,
        userDefinedAffiliation: ''
    };

    $scope.profileDataModel = function () {
        $scope.profileData = {
            InstitutionId: "",
            InstitutionName: "",
            teamDisplayName: "",
            adminFirstName: "",
            adminLastName: "",
            adminEmailId: "",
            startDate: "",
            noOfLicenses: "",
            advantageAccount: "",
            subscriptionAllowed: 'year',
            additionalComments: "",
            isKratosData: false
        }
    };

    $scope.profileDataModel();

    $scope.reloadDatePicker = function () {
        $('.daterangepickerInp').daterangepicker({
            singleDatePicker: true,
            showDropdowns: true,
            minDate: new Date(),
            locale: {
                format: 'MM-DD-YYYY'
            }
        });
    }

    $scope.reloadDatePicker();

    $scope.selectAffiliation = function () {
        $('#affiliationName').val('');
        $scope.selectedInstitute.userDefinedAffiliation = "";
        $scope.selectedInstitute.InstitutionId = $scope.profileData.InstitutionId;
        if (!$scope.selectedInstitute.isAffiliationExists) {
            $scope.selectedInstitute.InstitutionName = $scope.profileData.InstitutionName;
        } else {
            if ($scope.profileData.InstitutionName.length == 0) {
                $scope.selectedInstitute.isAffiliationExists = false
            }
            $scope.selectedInstitute.userDefinedAffiliation = $scope.profileData.InstitutionName;
        }

        $('#affiliation').modal('show');
    };

    $scope.getcountryData = function () {
        progressBarService.showProgressBar();
        $http({
            method: 'Get',
            url: serviceBase + "country",
            headers: {
                'Content-Type': 'application/json'
            }
        }).success(function (data, status) {
            if (data != null && data.message != undefined) {
                $scope.message = data.message;
                $scope.isError = true;
                $scope.isSuccess = false;
            }
            else {
                progressBarService.hideProgressBar();
                $scope.countries = data;
                $scope.profileData.eSpectraCountryID = '1';
            }
            progressBarService.hideProgressBar();
        }).error(function (data, status) {
        })

    }

    $scope.getcountryData();

    $scope.createTeam = function () {
        if ($scope.checkTeamDetails()) {
            progressBarService.showProgressBar();

            var teamRegistrationInfo = {
                RgoldID: parseInt($scope.profileData.InstitutionId) > 0 ? $scope.profileData.InstitutionId : 1,
                InstitutionName: $scope.profileData.InstitutionName,
                AdvAccntNum: $scope.profileData.advantageAccount,
                eSpectraCountryID: $scope.profileData.eSpectraCountryID,
                eSpectraOrderStartDate: $scope.profileData.startDate,
                eSpectraOrderQty: $scope.profileData.noOfLicenses,
                eSpectraTeam: [{
                    eSpectraTeamName: $scope.profileData.teamDisplayName,
                    eSpectraTeamAdminFirstName: $scope.profileData.adminFirstName,
                    eSpectraTeamAdminLastName: $scope.profileData.adminLastName,
                    eSpectraTeamAdminEmail: $scope.profileData.adminEmailId,
                    eSpectraTeamComment: $scope.profileData.additionalComments
                }],
                isKratosData: $scope.profileData.isKratosData ? 1 : 0
            };
            loginService.createInstitutionAccount(teamRegistrationInfo).then(function (response) {
                if (response != null && response.data.message != undefined) {
                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                }
                else {
                    $scope.message = GetMessage.teamCreated;
                    $scope.isError = false;
                    $scope.isSuccess = true;
                    $scope.selectedInstitute = {
                        InstitutionId: 0,
                        InstitutionName: '',
                        isAffiliationExists: false,
                        userDefinedAffiliation: ''
                    };
                    $scope.profileDataModel();
                    $scope.profileForm.$setPristine();
                    $scope.profileForm.$setUntouched();
                }
                progressBarService.hideProgressBar();
            });
        }
    };

    $scope.checkTeamDetails = function () {
        if ($scope.profileData.InstitutionName != "" && $scope.profileData.teamDisplayName != "" && $scope.profileData.adminFirstName != "" && $scope.profileData.adminLastName != "" && $scope.profileData.adminEmailId != "" && $scope.profileData.startDate != "" && $scope.profileData.noOfLicenses != "") {
            return true;
        } else {
            return false;
        }
    }
}]);
